import React from "react";
import { CheckboxProps } from "./Checkbox.types";
import { Body1MediumTypography } from "../../primitives/Typography/typographyVariants";
import {
  CheckboxContainer,
  CheckboxStyled,
  CheckboxWrapper,
  CheckIcon,
  CheckboxLabel,
} from "./Checkbox.styles";

export const Checkbox = ({
  checked,
  onChange,
  name,
  disabled = false,
  indeterminate = false,
  dataCy,
}: CheckboxProps) => {
  const icon = indeterminate ? "fa-minus" : "fa-check";
  return (
    <div>
      <CheckboxLabel data-cy={dataCy}>
        <CheckboxWrapper>
          <CheckboxContainer checked={checked} disabled={disabled}>
            <CheckIcon className={`fa-solid ${icon}`} />
          </CheckboxContainer>
          <Body1MediumTypography>{name}</Body1MediumTypography>
        </CheckboxWrapper>
        <CheckboxStyled type="checkbox" checked={checked} onChange={onChange} />
      </CheckboxLabel>
    </div>
  );
};
